import { PopoverOrigin } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { isNil } from 'ramda';
import { ReactNode, MouseEvent } from 'react';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { useHoverMenu } from '~/components/HoverMenu';

import { Count } from './ListCountCell.styled';

const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'center',
};
const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'center',
};

export type ListCountCellValue = Union.Nullable<number>;

interface ListCountCellProps<R extends GridValidRowModel = any> {
  value: ListCountCellValue;
  row: R;
  renderList?: () => ReactNode;
}

export const ListCountCell = <R extends GridValidRowModel = any>({ value, renderList }: ListCountCellProps<R>) => {
  const { menuOpen, menuClose, isDescendant } = useHoverMenu();

  const handleMenuOpen = (event: MouseEvent<HTMLElement>) => {
    menuOpen({
      anchorEl: event.currentTarget,
      anchorOrigin: ANCHOR_ORIGIN,
      transformOrigin: TRANSFORM_ORIGIN,
      children: renderList,
    });
  };
  const mouseLeave = (event: MouseEvent<any>) => {
    if (!isDescendant(event.relatedTarget as any)) {
      menuClose();
    }
  };
  if (!isNil(value)) {
    return (
      <Count onMouseEnter={renderList ? handleMenuOpen : undefined} onMouseLeave={mouseLeave}>
        {value}
      </Count>
    );
  }
  return <>{NULLISH_CELL_VALUE}</>;
};
